// src/components/admin/AdminLimites.js
import React, { useState, useEffect } from 'react';
import { listarConfiguraciones, actualizarConfiguracion } from '../../services/api';

const AdminLimites = () => {
  const [configs, setConfigs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editando, setEditando] = useState({});
  const [valoresTemp, setValoresTemp] = useState({});
  const [mensaje, setMensaje] = useState({ type: '', text: '' });

  useEffect(() => {
    cargarConfiguraciones();
  }, []);

  const cargarConfiguraciones = async () => {
    setLoading(true);
    try {
      const response = await listarConfiguraciones();
      setConfigs(response.data.configuraciones);
      
      // Inicializar valores temporales
      const temp = {};
      response.data.configuraciones.forEach(config => {
        temp[config.clave] = config.valor;
      });
      setValoresTemp(temp);
    } catch (error) {
      console.error('Error cargando configuraciones:', error);
      setMensaje({ type: 'error', text: 'Error al cargar configuraciones' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (clave, valor) => {
    setValoresTemp({
      ...valoresTemp,
      [clave]: valor
    });
  };

  const handleGuardar = async (clave) => {
    try {
      await actualizarConfiguracion(clave, valoresTemp[clave]);
      setMensaje({ 
        type: 'success', 
        text: 'Límite actualizado correctamente' 
      });
      setEditando({});
      cargarConfiguraciones();
      setTimeout(() => setMensaje({ type: '', text: '' }), 3000);
    } catch (error) {
      setMensaje({ type: 'error', text: 'Error al actualizar límite' });
    }
  };

  const iniciarEdicion = (clave) => {
    setEditando({ [clave]: true });
  };

  const cancelarEdicion = () => {
    setEditando({});
    // Restaurar valores originales
    cargarConfiguraciones();
  };

  if (loading) return <div className="loading">Cargando configuraciones...</div>;

  return (
    <div className="admin-limites">
      <h2>⚖️ Límites Beta Globales</h2>
      <p className="section-desc">Configura los límites por defecto para nuevos usuarios beta</p>

      {mensaje.text && (
        <div className={`mensaje ${mensaje.type}`}>{mensaje.text}</div>
      )}

      <div className="config-grid">
        {configs.map(config => (
          <div key={config.id} className="config-card">
            <div className="config-info">
              <h3>{config.clave.replace(/_/g, ' ')}</h3>
              <p>{config.descripcion}</p>
            </div>
            <div className="config-control">
              {config.tipo === 'boolean' ? (
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={valoresTemp[config.clave] === 'true'}
                    onChange={(e) => {
                      const nuevoValor = e.target.checked ? 'true' : 'false';
                      handleChange(config.clave, nuevoValor);
                      handleGuardar(config.clave);
                    }}
                  />
                  <span className="slider"></span>
                </label>
              ) : (
                <div className="number-input-container">
                  {editando[config.clave] ? (
                    <>
                      <input
                        type="number"
                        value={valoresTemp[config.clave]}
                        onChange={(e) => handleChange(config.clave, e.target.value)}
                        className="limite-input"
                        min="0"
                        step="1"
                        autoFocus
                      />
                      <div className="input-actions">
                        <button 
                          onClick={() => handleGuardar(config.clave)}
                          className="btn-guardar-pequeno"
                          title="Guardar"
                        >
                          💾
                        </button>
                        <button 
                          onClick={cancelarEdicion}
                          className="btn-cancelar-pequeno"
                          title="Cancelar"
                        >
                          ❌
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="valor-container">
                      <span className="valor-actual">{valoresTemp[config.clave]}</span>
                      <button 
                        onClick={() => iniciarEdicion(config.clave)}
                        className="btn-editar-pequeno"
                        title="Editar"
                      >
                        ✏️
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="info-box">
        <h4>ℹ️ Acerca de los límites globales</h4>
        <ul>
          <li>Los límites se aplican a TODOS los nuevos usuarios beta</li>
          <li>Los cambios no afectan a usuarios existentes</li>
          <li>Para modificar límites de usuarios específicos, ve a la sección Usuarios</li>
        </ul>
      </div>
    </div>
  );
};

export default AdminLimites;